// Pastilla de carpeta. Es el control con el que el panel de Archivos filtra por
// tipo; vive suelto (y no adentro de `VideoEditor`) desde que el panel de Marca
// y el **selector de imagen** dibujan las suyas con la misma forma en vez de
// inventar cada uno otro control.
export const clasesDePastilla = (activa: boolean): string =>
  `inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[12px] font-medium transition-colors ${
    activa
      ? "bg-[rgb(var(--brand-primary-rgb)_/_0.1)] text-brand-primary"
      : "bg-black/[0.04] text-brand-black/50 hover:bg-black/[0.07]"
  }`;
